import RoleUpdateService from './RoleUpdateService';

export default RoleUpdateService;
